import {forwardRef} from 'react'
import {type TextProps} from 'react-native'
import Svg, {type PathProps, type SvgProps} from 'react-native-svg'
import {Image} from 'expo-image'

import {LucideGrapePaths} from '#/view/icons/GrapeIcon'
import {useLogoVariant} from '#/view/icons/useLogoVariant'
import {flatten} from '#/alf'

const BRAND = '#C22EFF'
const ratio = 1

type Props = {
  allowVariants?: boolean
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

function resolveFill(fill?: PathProps['fill']) {
  if (!fill || fill === 'sky') return BRAND
  return fill
}

/**
 * App mark: Lucide grape (stroke). Japan / kawaii variants unchanged.
 */
export const Logo = forwardRef(function LogoImpl(props: Props, ref) {
  const {allowVariants = true, fill, ...rest} = props
  const styles = flatten(props.style)
  // @ts-expect-error it's fiiiiine
  const size = parseInt(rest.width || 32, 10)
  const color = resolveFill(fill)

  const logoVariant = useLogoVariant(allowVariants)

  if (logoVariant !== 'default') {
    const isJapanLogo = logoVariant === 'japan'
    return (
      <Image
        source={
          isJapanLogo
            ? require('../../../assets/icons/custom_logo_japan.svg')
            : size > 100
              ? require('../../../assets/kawaii.png')
              : require('../../../assets/kawaii_smol.png')
        }
        accessibilityLabel="GrapeVyne"
        accessibilityHint=""
        accessibilityIgnoresInvertColors
        style={[{height: size, aspectRatio: isJapanLogo ? 2 : 1.4}]}
      />
    )
  }

  return (
    <Svg
      fill="none"
      // @ts-expect-error it's fiiiiine
      ref={ref}
      viewBox="0 0 24 24"
      accessibilityLabel="GrapeVyne"
      accessibilityHint=""
      {...rest}
      width={size}
      height={size * ratio}
      style={[{width: size, height: size * ratio}, styles]}
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round">
      <LucideGrapePaths />
    </Svg>
  )
})
